import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import withRoute from '@/pages/withRoute';
import OrdersPage from './OrdersPage';
import './OrdersPage.less';

export const prefix = 'bm-p-orders';

const RouteComponent: React.FC<RouteComponentProps> = props => withRoute({
  pageComponent: OrdersPage,
  routeProps: props,
  pageTitleI18nKey: '',
});

export default RouteComponent;
